import { render, staticRenderFns } from "./Model17.vue?vue&type=template&id=27918651&scoped=true&"
import script from "./Model17.vue?vue&type=script&lang=js&"
export * from "./Model17.vue?vue&type=script&lang=js&"
import style0 from "./Model17.vue?vue&type=style&index=0&id=27918651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27918651",
  null
  
)

export default component.exports